import React  from 'react'
// import { connect } from "react-redux";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReleaseNoteModal from '../components/ReleaseNoteModal';
import { useDispatch } from 'react-redux';
import { downloadFirmwareFile } from '../api/managefileapi';

const columns = [
  { id: 'controllername', label: 'Controller' },
  { id: 'firmware_version', label: 'Version' },
  { id: 'actions', label: 'Actions'}
];

export default function FirmwareHistoryItem({firmwareList}) {
  
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage]  = React.useState(10);
    const [open, setOpen] = React.useState(false);
    const [releaseNotes,setReleaseNotes] = React.useState('');
    const dispatch = useDispatch();

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    const handleRedirect =(rowId,fileName) => {
      dispatch(downloadFirmwareFile(rowId,fileName));
    };

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
        setOpen(false);
    };

  return (
    <>
      
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                { firmwareList?.length > 0 ? firmwareList
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row,i) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === 'number'
                                ? column.format(value)
                                : 
                                column.id === 'actions' ?
                                <>
                                <Stack spacing={2} direction="row">
                                  <Tooltip title="View Release Notes">
                                    <VisibilityIcon 
                                      onClick={()=> handleClickOpen(setReleaseNotes(row.description))}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Download">
                                    <DownloadIcon 
                                      onClick={(e) => handleRedirect(row['id'],row['file_name'])}
                                      sx={{cursor:'pointer'}}
                                    />
                                  </Tooltip>
                                </Stack>
                              </>
                            : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
        { firmwareList?.length > 0 ?  
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={firmwareList?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          : <></> }
      </Paper>
      <ReleaseNoteModal
        open={open}
        onClose={handleClose}
        description={releaseNotes}
      />
    </>
  );
}
